<div class="administrative-configuration__container">
    <div class="d-flex justify-content-between align-items-baseline">
        <div class="text-strong mb-2">
            Configuración de facturación
        </div>
    </div>
    <!-- 1. Días de vencimiento de la facturación -->
    <div id="billingExpirationStep" class="administrative-configuration__billing-expiration mt-3">
        <div class="text-strong administrative-configuration__billing-expiration__title">1. Días acordados para el pago
            de facturas</div>
        <div class="administrative-configuration__billing-expiration__info">
            <p class="my-2">Este plazo de pago define el <b><u>tiempo máximo de pago</u></b> acordado por contrato para
                cada servicio.</p>
            <div class="administrative-configuration__billing-expiration__info--input">
                <mat-form-field appearance="standard" class="col-md-6 col-lg-4 px-0">
                    <mat-label>Cantidad de días</mat-label>
                    <input matInput type="number" min="0" [max]="maxExpirationDays"
                        [formControl]="expirationDaysControl" />
                    <i matSuffix (click)="updateExpirationDays()" class="fas fa-save text-success cursor-pointer"
                        matTooltip="Guardar"></i>
                    <mat-error *ngIf="expirationDaysControl?.errors?.max">
                        {{utils.giveMessageError('MAX_VALUE_EXCEED', 'cantidad de días', maxExpirationDays)}}
                    </mat-error>
                    <mat-error *ngIf="expirationDaysControl?.errors?.min">
                        {{utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'cantidad de días', 0)}}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    <!-- 2. Prefactura -->
    <div id="preInvoiceStep" class="administrative-configuration__pre-invoice mt-3">
        <div class="text-strong administrative-configuration__pre-invoice__title">2. Prefactura</div>
        <div class="administrative-configuration__pre-invoice__info">
            <p class="my-2">La prefactura permite visualizar un <b><u>resumen de los valores a facturar</u></b> previos
                a la factura real para ser confirmados por el cliente final.</p>
            <div class="administrative-configuration__pre-invoice__info--input d-flex align-items-center">
                <label class="text-strong mr-3">Requiere prefactura</label>
                <mat-button-toggle-group [formControl]="requiresPreInvoiceControl"
                    (change)="onRequiresPreInvoiceChange()">
                    <mat-button-toggle [value]="true">Sí</mat-button-toggle>
                    <mat-button-toggle [value]="false">No</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <div class="administrative-configuration__pre-invoice__fields mt-4" *ngIf="requiresPreInvoiceControl.value">
                <p class="my-2">Agregue los campos del catálogo y defina el orden en que aparecerán en la prefactura.
                    Solo los campos del listado se incluirán en el archivo exportado.</p>
                <div class="administrative-configuration__pre-invoice__fields__title">CAMPOS DE LA PREFACTURA</div>
                <mat-form-field appearance="standard"
                    class="administrative-configuration__pre-invoice__fields__selector col-md-6 col-lg-4 px-0">
                    <mat-label>Agregar campo</mat-label>
                    <mat-select [formControl]="preBillFieldToAddControl" (selectionChange)="addPreBillField($event)"
                        [disabled]="loadingPreBillFields || !availablePreBillCatalogItems.length">
                        <mat-option *ngFor="let item of availablePreBillCatalogItems" [value]="item.id"
                            [disabled]="item.disabled">
                            {{ item.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <div class="administrative-configuration__pre-invoice__fields__list"
                    *ngIf="preBillOptions.length; else emptyPreBillFields" cdkDropList
                    (cdkDropListDropped)="dropPreBillField($event)">
                    <div class="administrative-configuration__pre-invoice__fields__item" cdkDrag
                        *ngFor="let option of preBillOptions; let i = index">
                        <div class="administrative-configuration__pre-invoice__fields__info">
                            <i class="fas fa-grip-vertical administrative-configuration__pre-invoice__fields__drag"
                                cdkDragHandle></i>
                            <span class="administrative-configuration__pre-invoice__fields__order">{{ i + 1 }}</span>
                            <div class="administrative-configuration__pre-invoice__fields__name-wrap">
                                <span class="administrative-configuration__pre-invoice__fields__name"
                                    [matTooltip]="option.name">{{ option.name }}</span>
                                <small class="administrative-configuration__pre-invoice__fields__description"
                                    *ngIf="option.description">{{ option.description }}</small>
                            </div>
                        </div>
                        <div class="administrative-configuration__pre-invoice__fields__alias-wrap">
                            <label class="administrative-configuration__pre-invoice__fields__alias-label"
                                [attr.for]="'preBillAlias-' + i">Alias</label>
                            <input type="text" class="administrative-configuration__pre-invoice__fields__alias"
                                [id]="'preBillAlias-' + i" [(ngModel)]="option.alias"
                                [ngModelOptions]="{standalone: true}" placeholder="Opcional" />
                        </div>
                        <button type="button"
                            class="administrative-configuration__pre-invoice__fields__remove"
                            matTooltip="Quitar campo"
                            (click)="removePreBillField(option); $event.stopPropagation()">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
                <ng-template #emptyPreBillFields>
                    <div class="administrative-configuration__pre-invoice__fields__empty">
                        {{ preBillEmptyMessage }}
                    </div>
                </ng-template>
                <div class="button-container">
                    <button mat-raised-button color="primary" type="button"
                        class="button-width-auto bg-color-primary administrative-configuration__pre-invoice__fields__save mt-3"
                        [disabled]="loadingPreBillFields || !preBillOptions.length" (click)="savePreBillFields()">
                        Guardar configuración
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>